import Vue from 'vue'
import Vuex from 'vuex'
import Sortable from 'vue-sortable'
import App from './App.vue'
import _ from "lodash"
import store from './store/'
import router from './router'
import KeenUI from 'keen-ui'
import VueCookie from 'vue-cookie'
import VueLocalStorage from 'vue-localstorage'
 
Vue.use(VueLocalStorage)
Vue.use(Vuex)
Vue.use(Sortable)
Vue.use(KeenUI)
Vue.use(VueCookie)

new Vue({
	el: '#app',
	store,
	router,
	render: h => h(App)
})

Vue.mixin({
    methods: {
        makeNonReactiveCopy(original) {
        	console.log("make copy")
            if (! _.isObject(original) || _.isArray(original)) {

                return original
            }

            let copy = {}
            let attributes = Object.keys(original)
            attributes.forEach(attribute => {
                let attributeValue = Object.getOwnPropertyDescriptor(original, attribute)
                Object.defineProperty(copy, attribute, {
                    __proto__: null,
                    value: attributeValue.get()
                })
            })

            return copy
        },
        backup(original) {
            return this.makeNonReactiveCopy(original)
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js